import { HHTextField } from '@hinge-health/react-component-library';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export interface EffectiveYearInputProps {
  disabled?: boolean;
}

export const EffectiveYearInput = ({
  disabled,
}: EffectiveYearInputProps): JSX.Element => {
  const {
    control,
    trigger,
    formState: { errors },
    watch,
  } = useFormContext();

  const partnershipId = watch('partnershipId');
  const clientId = watch('clientId');

  useEffect(() => {
    trigger('effectiveYear');
  }, [partnershipId, clientId, trigger]);

  const error = errors.effectiveYear;

  return (
    <Controller
      control={control}
      name="effectiveYear"
      render={({ field: { onChange, value } }): JSX.Element => (
        <HHTextField
          hhVariant="variant-bypass"
          variant="outlined"
          id="effective-year"
          label="Effective Year"
          type="number"
          value={value ?? ''}
          onChange={(e): void => {
            const parsed = parseInt(e.target.value);
            onChange(isNaN(parsed) ? null : parsed);
          }}
          disabled={disabled}
          error={!!error}
          helperText={error?.message as string}
          inputProps={{ name: 'effectiveYear' }}
        />
      )}
    />
  );
};
